import ImageHelper from "./ImageHelper";
import VideoHelper from "./VideoHelper";
import AudioHelper from './AudioHelper';

const BLOCK_TYPES = {
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
    'blockquote': 'blockquote',
    'unordered-list-item': 'ul',
    'ordered-list-item': 'ol',
    'code-block': 'pre',
    'unstyled': 'p',
};

const INLINE_TYPES = {
    'BOLD': 'b',
    'ITALIC': 'i',
    'UNDERLINE': 'u',
    'CODE': 'code',
};

export default class DraftHelper {

    static contentStateToHtml(contentState) {
        try {
            const {blocks, entityMap} = contentState;

            const htmlBlocks = [];

            for (let i = 0; i < blocks.length; i++) {
                const block = blocks[i];
                const text = block.text.trim();

                if (block.type !== 'atomic' && text.length === 0) {
                    continue;
                }

                const prevBlock = blocks[i - 1];
                const nextBlock = blocks[i + 1];

                if (block.type === 'unordered-list-item') {
                    if (!prevBlock || prevBlock.type !== block.type) {
                        htmlBlocks.push('<ul>');
                    }
                    htmlBlocks.push(`<li>${getBlockInnerHtml(block, entityMap)}</li>`);
                    if (!nextBlock || nextBlock.type !== block.type) {
                        htmlBlocks.push('</ul>');
                    }
                    continue;
                }

                if (block.type === 'ordered-list-item') {
                    if (!prevBlock || prevBlock.type !== block.type) {
                        htmlBlocks.push('<ol>');
                    }
                    htmlBlocks.push(`<li>${getBlockInnerHtml(block, entityMap)}</li>`);
                    if (!nextBlock || nextBlock.type !== block.type) {
                        htmlBlocks.push('</ol>');
                    }
                    continue;
                }

                if (block.type === 'atomic') {
                    if (block.entityRanges.length > 0) {
                        const {key} = block.entityRanges[0];
                        const entity = entityMap[key];

                        if (entity) {
                            try {
                                const obj = entity.data;

                                if (entity.type === 'IMAGE') {
                                    htmlBlocks.push(`<figure class="image-wrapper">`);
                                    htmlBlocks.push(`<div class="inner" style="width: ${obj.width}px">`);

                                    htmlBlocks.push(`<div class="aspect-container">`);
                                    htmlBlocks.push(`<div class="aspect-ratio" style="padding-bottom: ${100 * obj.height / obj.width}%">`);
                                    htmlBlocks.push(`<img src="${ImageHelper.getUrl(obj)}" srcset="${ImageHelper.getAttrSrcset(obj)}" sizes="${ImageHelper.getAttrSizes(obj)}" title="${obj.title}" alt="${obj.title}"/>`);
                                    htmlBlocks.push(`</div>`);
                                    htmlBlocks.push(`</div>`);

                                    // htmlBlocks.push(`<figcaption class="caption">${obj.title}</figcaption>`);

                                    htmlBlocks.push(`</div>`);
                                    htmlBlocks.push(`</figure>`);

                                    continue;
                                }

                                if (entity.type === 'VIDEO') {
                                    htmlBlocks.push(`<figure class="video-wrapper">`);
                                    htmlBlocks.push(`<div class="inner" style="width: ${obj.width}px">`);

                                    htmlBlocks.push(`<div class="aspect-container">`);
                                    htmlBlocks.push(`<div class="aspect-ratio" style="padding-bottom: ${100 * obj.height / obj.width}%">`);
                                    htmlBlocks.push(`<video src="${VideoHelper.getUrl(obj)}" title="${obj.title}" controls controlslist="nodownload"></video>`);
                                    htmlBlocks.push(`</div>`);
                                    htmlBlocks.push(`</div>`);

                                    // htmlBlocks.push(`<figcaption class="caption">${obj.title}</figcaption>`);

                                    htmlBlocks.push(`</div>`);
                                    htmlBlocks.push(`</figure>`);

                                    continue;
                                }

                                if (entity.type === 'AUDIO') {
                                    htmlBlocks.push(`<figure class="audio-wrapper">`);
                                    
                                    htmlBlocks.push(`<audio src="${AudioHelper.getUrl(obj)}" title="${obj.title}" controls controlslist="nodownload"></audio>`);
                                    
                                    // htmlBlocks.push(`<figcaption class="caption">${obj.title}</figcaption>`);
                                    
                                    htmlBlocks.push(`</figure>`);

                                    continue;
                                }

                                if (entity.type === 'IFRAME') {
                                    htmlBlocks.push(`<figure class="iframe-wrapper">`);
                                    htmlBlocks.push(`<div class="inner" style="width: ${obj.width}px">`);

                                    htmlBlocks.push(`<div class="aspect-container">`);
                                    htmlBlocks.push(`<div class="aspect-ratio" style="padding-bottom: ${100 * obj.height / obj.width}%">`);
                                    htmlBlocks.push(`<iframe src="${obj.src}" title="${obj.title}"></iframe>`);
                                    htmlBlocks.push(`</div>`);
                                    htmlBlocks.push(`</div>`);

                                    // htmlBlocks.push(`<figcaption class="caption">${obj.title}</figcaption>`);

                                    htmlBlocks.push(`</div>`);
                                    htmlBlocks.push(`</figure>`);

                                    continue;
                                }

                            } catch (e) {
                                console.log(e);
                            }
                        }
                    }
                    continue;
                }

                const tag = BLOCK_TYPES[block.type];
                if (tag) {
                    htmlBlocks.push(`<${tag}>${getBlockInnerHtml(block, entityMap)}</${tag}>`);
                }
            }

            return htmlBlocks.join('');

        } catch (e) {

            console.error(e);
            return contentStateJson;
        }

    }

}


function getBlockInnerHtml(block, entityMap) {
    const {text, inlineStyleRanges: styleRanges, entityRanges} = block;

    try {
        let mixedRanges = styleRanges.concat(entityRanges);

        // avoid overlaps
        mixedRanges.sort((a, b) => a.offset - b.offset);
        let minAllowedOffset = 0;
        mixedRanges = mixedRanges.filter(rg => {
            if (rg.offset < minAllowedOffset) {
                return false;
            }
            minAllowedOffset = rg.offset + rg.length;
            return true;
        });

        const isStyleRange = rg => rg.hasOwnProperty('style');

        const map = {};

        mixedRanges.forEach(rg => {
            map[rg.offset] = '';
            map[rg.offset + rg.length] = '';
        });

        mixedRanges.forEach(rg => {
            if (isStyleRange(rg)) {
                const tag = INLINE_TYPES[rg.style];
                map[rg.offset + rg.length] += '</' + tag + '>';
                return;
            }

            const entity = entityMap[rg.key];

            if (entity.type === 'LINK' && entity.data.url) {
                map[rg.offset + rg.length] += '</a>';
            }
        });

        mixedRanges.forEach(rg => {
            if (isStyleRange(rg)) {
                const tag = INLINE_TYPES[rg.style];
                map[rg.offset] += '<' + tag + '>';
                return;
            }

            const entity = entityMap[rg.key];

            if (entity.type === 'LINK' && entity.data.url) {
                const {url, title, target, rel} = entity.data;

                const attrs = [
                    `href="${url}"`,
                    title && `title="${title}"`,
                    target && `target="${target}"`,
                    rel && `rel="${rel}"`,
                ].filter(Boolean);

                map[rg.offset] += `<a ${attrs.join(' ')}>`;
            }
        });

        const indexes = [];
        for (let index in map) {
            indexes.push(Number(index));
        }
        indexes.sort((a, b) => a - b);

        const subTexts = [];
        const tags = [];
        let remainText = text;
        indexes.forEach(index => {
            tags.push(map[index]);

            const subIndex = index - (text.length - remainText.length);
            subTexts.push(remainText.substring(0, subIndex));
            remainText = remainText.substring(subIndex);
        });

        let result = '';

        for (let i = 0; i < subTexts.length; i++) {
            result += subTexts[i];
            result += tags[i];
        }

        result += remainText;

        return result;

    } catch (e) {

        console.log(e);
        return text;
    }
}
